<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-accidents"></div>
      <div class="card-body">
        <h4 class="title">بیمه کرونا</h4>
        <br>
        <p>
          یافتن بیمه کرونا مطمئن کاری است که ما
          <br>
          به بهترین نحو برای شما انجام میدهیم.
        </p>
        <br>
        <br>
        <br>
        <br>
        <app-custom-button [disabled]="false"
                           [BackButton]="true"
                           [LabelText]="'خرید بیمه'"
                           [Show]="true"
                           [backButtonLabel]="'بیمه های من'"
                           [backUrl]="'/INDIVIDUAL_ACCIDENTS/requests'"
                           (OnClick)="buy()"
        ></app-custom-button>
      </div>
    </div>
  </div>
</div>
